import { makeAutoObservable } from "mobx"
import { openApi } from "../../helpers/request";
import { notification } from "antd";
import i from "../../translations/i";

class OptionTypesController {

  items: any[] = []
  options: any[] = []
  render: boolean = false

  constructor() {
    makeAutoObservable(this)
  }

  get(types: string[] = [], keys: string[] = []) {
    let uri = `/options/types?`

    types.map((key: string) => uri += `types[]=${key}&`)
    keys.map((key: string) => uri += `keys[]=${key}&`)

    return openApi('get', uri)
      .then((result: any) => {
        this.items = result.data
        this.render = true

        return result.keys ?? []
      })
      .catch((err: any) => console.log(err.response))
  }

  getOptions(keys: string[] = []) {

    let uri = `/options?`

    keys.map((key: string) => uri += `&keys[]=${key}`)

    openApi('get', uri)
      .then(result => {
        console.log(result.data)
        this.items = result.data
        this.render = true
      })
  }

  save(keys: string[], items: any[]) {
    const data = new FormData()
    Object.keys(items).map((key: string) => {
      // @ts-ignore
      let value = this.items[key]
      if(typeof value === 'boolean')
        value = value ? '1' : '0'
      data.append(key, value);
    })

    openApi('post', 'options', data)
      .then(result => {
        console.log(result.data)
        notification.success({
          message: i.t('def:success.success'),
          description: i.t('def:success.edit'),
        })
      })
      .catch(err => console.log(err.response))
  }
}

export default new OptionTypesController();